var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-digital-flop"},_vm._l((_vm.numbers),function(i){return _c('span',{class:("" + (i==','?'string-flop':'number-flop'))},[_vm._v(_vm._s(i))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }